import React from 'react';
import styled from 'styled-components';
import { Body5, Body7 } from '@ui';

// A key/value list: label column sized to its content, value column takes the rest. The same
// grid SpecEditor keeps privately for a spec's provenance block. The grid is this file's; the type
// is the house text components (Body7 label, Body5 value), not raw dt/dd font rules. The label IS
// the <dt> (`as`), so a caller's test can still tell the label text from a value rendered as a span.

const List = styled.dl`
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: 8px 20px;
  margin: 0;
`;

const Dd = styled.dd`
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
`;

// `rows` is `[{ label, value }]`; a row whose value is null or undefined is left out, so callers
// can list every field they know about and only the present ones render.
export const DefList = ({ rows }) => (
  <List>
    {rows
      .filter((row) => row && row.value !== null && row.value !== undefined && row.value !== '')
      .map((row) => (
        <React.Fragment key={row.label}>
          {/* Full text, not dim: the label is the only thing that says what the value IS, and a dim
              label a size down from its value was the hardest line on the page to read. */}
          <Body7 as="dt">{row.label}</Body7>
          <Dd>
            <Body5>{row.value}</Body5>
          </Dd>
        </React.Fragment>
      ))}
  </List>
);
